import React from 'react';
import { useSelector } from 'react-redux';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useBeneficiarySettings } from './hooks/useBeneficiarySettings';
import BeneficiaryLandingPageView from './beneficiary-landing-page-view';
import { TcsmStates } from '../../../../root/tcsm-model';
import { BeneficiarySettings } from './model/epi-props';
import { BeneficiaryData } from './model/beneficiary-models';
import { getBeneficiaryPageModel } from './helper/beneficiary-helper';
import { useQuery } from '../../../../global/hooks/useQuery';

interface Props {
	settingsId: string;
}
export function BeneficiaryLanding(props: Props) {

	const { settingsId } = props;
	const loaded = useBeneficiarySettings(settingsId);
	const settings = useSelector<TcsmStates, BeneficiarySettings>(state => state?.epiProps?.beneficiarySettingsState?.epiContent);
	const beneficiaryData = useSelector<TcsmStates, BeneficiaryData>(state => state?.beneficiariesState?.beneficiaries);
	const success = useQuery().get('status');

	if (!loaded) {
		return <LoadingCircle />;
	}

	return (
		<BeneficiaryLandingPageView settings={settings} beneficiaryLandingPageModel={getBeneficiaryPageModel(beneficiaryData, success === 'success')} />
	);
}